import * as React from 'react'
import { memo } from 'react'
const SvgArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 6">
    <path d="m0 2.64 18.72-.12A3.9 3.9 0 0 1 17.64 0 16.5 16.5 0 0 0 24 3a15.7 15.7 0 0 0-6.36 3 4.1 4.1 0 0 1 1.2-2.52L0 3.6Z" />
  </svg>
)
const Memo = memo(SvgArrowRight)
export default Memo
